import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

export interface RemoteConfigRow {
    id: number;
    provider: string;
    key: string;
    type: string;
    value: string;
    description?: string | null;
    created_at?: string;
    updated_at?: string;
}

@Injectable()
export class RemoteConfigService extends BaseAPIService {

    private ROUTES = {
        list: '/remote-config',
        item: '/remote-config/:provider/:key'
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    // 전체 row 목록 조회
    listConfigs(): Promise<RemoteConfigRow[]> {
        return this.GET<RemoteConfigRow[]>(this.ROUTES.list).toPromise();
    }

    // provider + key 로 row 조회
    getConfig(provider: string, key: string): Promise<RemoteConfigRow> {
        return this.GET<RemoteConfigRow>(this.ROUTES.item, { provider, key }).toPromise();
    }

    // value / description 수정 (value 는 string 직렬화 필요)
    updateConfig(provider: string, key: string, patch: { value?: string; description?: string | null }): Promise<any> {
        return this.PUT(this.ROUTES.item, { provider, key }, patch).toPromise();
    }
}
